import { r } from "./utils-BUfVYLTt.js";

class ProductForm extends HTMLElement {
    constructor() {
        super()

        this.unsubscribe = null

        this.minus = this.querySelector('[js-product-form="minus"]')
        this.plus = this.querySelector('[js-product-form="plus"]')
        this.quantity = this.querySelector('[js-product-form="quantity"]')
        this.form = this.querySelector('[js-product-form="form"]')
        this.bisForm = this.querySelector('[js-product-form="bis"]')
    }

    connectedCallback() {
        this.init()
        this.setEventListeners()

        if (this.bisForm) {
            r(this.bisForm)
        }
    }

    setEventListeners() {
        document.addEventListener("click", event => {
            if (event.target === this.minus) {
                this.updateQuantity("decrement")
            }

            if (event.target === this.plus) {
                this.updateQuantity("increment")
            }

            if (event.target === this.quantity) {
                this.updateQuantity("input")
            }
        })

        document.addEventListener("submit", async event => {
            if (event.target === this.form) {
                event.preventDefault()

                try {
                    this.classList.add("is-loading")

                    const hasSelectedVariant = this.querySelector('[name="id"]')

                    if (!hasSelectedVariant || hasSelectedVariant.value === "") {
                        document
                            .querySelector('[js-product-details="error"]')
                            ?.classList.remove("is-hidden")

                        return
                    }

                    document
                        .querySelector('[js-product-details="error"]')
                        ?.classList.add("is-hidden")

                    const formData = new FormData(this.form);

                    const crossSellModal = document.querySelector('cross-sell-modal');
                    const crossSellModalId = crossSellModal?.dataset?.sectionId
                    if (crossSellModal && crossSellModal.dataset.sectionId) {
                        formData.append('sections', crossSellModalId);
                    }

                    const response = await fetch(
                        `${window.Shopify.routes.root}cart/add.js`,
                        {
                            method: "POST",
                            body: formData
                        }
                    )

                    if (!response.ok) {
                        throw new Error("Something went wrong")
                    }

                    const qty = Number(formData.get("quantity") || 1)
                    document.querySelectorAll("[js-cart-count]").forEach(element => {
                        element.textContent = (Number(element.textContent) + qty).toString()
                        element.classList.remove("is-hidden")
                    })

                    const data = await response.json();

                    const body = document.querySelector('body');
                    if (data && data.sections && crossSellModalId && data.sections[crossSellModalId] && body) {
                        //Open modal
                        body.style.overflow = 'hidden'
                        crossSellModal.removeAttribute('hidden');
                        requestAnimationFrame(() => {
                            const focusTarget = crossSellModal.querySelector('.cross-sell-modal__close') || crossSellModal;
                            focusTarget.focus();
                        });

                        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_opening-modal');

                        // Data for the cross-sell-modal to update itself
                        crossSellModal.dispatchEvent(new CustomEvent("newItemForModal", { detail: { html: data.sections[crossSellModalId], addedLineItemId: data.id } }));
                    }

                    const atc = this.querySelector('button[type="submit"]')
                    const initialAtcText =
                        this.getAttribute("data-atc-text") || "Add to cart"
                    const productAddedText =
                        this.getAttribute("data-added-text") || "Added"

                    if (!atc) {
                        return
                    }

                    atc.textContent = productAddedText

                    setTimeout(() => {
                        atc.textContent = initialAtcText
                    }, 3500)
                } catch (error) {
                    console.error(error)
                } finally {
                    this.classList.remove("is-loading")
                }
            }
        })
    }

    updateQuantity(type) {
        const input = this.querySelector('[name="quantity"]')
        const value = parseInt(input.value, 10)

        if (type === "increment") {
            input.value = (value + 1).toString()
        }

        if (type === "decrement") {
            if (value <= 1) {
                return
            }

            input.value = (value - 1).toString()
        }

        if (type === "input") {
            const newValue = Number(input.value)

            if (newValue < 1) {
                input.value = "1"
            }

            if (isNaN(newValue)) {
                input.value = "1"
            }

            if (newValue === value) {
                return
            }

            input.value = newValue.toString()

            return
        }
    }

    init() {
        const listener = event => {
            const variantEvent = event
            const sectionId = this.getAttribute("data-section-id")

            if (!sectionId) {
                return
            }

            const section = variantEvent.detail.sections[sectionId]

            if (!section) {
                return
            }

            const newMarkup = new DOMParser()
                .parseFromString(section, "text/html")
                .querySelector(this.tagName.toLocaleLowerCase())

            if (!newMarkup) {
                return
            }

            this.replaceWith(newMarkup)

            const variantInput = document.querySelector('[name="id"]')

            if (variantEvent.detail.id && variantInput) {
                variantInput.value = variantEvent.detail.id.toString()
            }
        }

        document.addEventListener("variant:update", listener)

        this.unsubscribe = () =>
            document.removeEventListener("variant:update", listener)
    }

    disconnectedCallback() {
        if (this.unsubscribe) {
            this.unsubscribe()
        }
    }
}

customElements.define("uwp-product-form", ProductForm)
